export default __webpack_public_path__ + "static/logo-aretanet-02dbca3fb9c44c1d783e8dcd604e719f.png";